var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckMark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.97 13.65Q5.68 13.65 6.05 14.82Q6.78 17.02 7.09 17.02Q7.33 17.02 7.59 16.65Q12.73 8.41 17.11 3.32Q18.25 2 20.72 2Q21.3 2 21.51 2.11Q21.71 2.22 21.71 2.38Q21.71 2.64 21.1 3.39Q14.03 11.89 7.99 21.34Q7.57 22 6.27 22Q4.95 22 4.71 21.89Q4.09 21.62 3.25 19.09Q2.29 16.29 2.29 15.57Q2.29 14.8 3.58 14.09Q4.36 13.65 4.97 13.65Z",
    fill: "#4CAF50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMark);
export default __webpack_public_path__ + "static/media/check-mark.582c2ef027c82a1bf45e18b5a3cc72dc.svg";
export { ForwardRef as ReactComponent };